(function(){
'use strict';
var root=document.getElementById('icb'); if(!root) return;
var data=JSON.parse(document.getElementById('icb-data').textContent);
// glove picker sheet: lift to <body> so the product gallery can't cover it
var gsheet=document.getElementById('icb-sheet'); if(gsheet && gsheet.parentNode!==document.body) document.body.appendChild(gsheet);
var CONV=data.conv||[]; if(!CONV.length) return;
var pick=0;
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function cap(s){s=String(s).toLowerCase();return s.charAt(0).toUpperCase()+s.slice(1);}
function giftHtml(){
 var c=CONV[pick]||CONV[0];
 return '<div class="icb-slot icb-gift"><div class="icb-slot-head"><img class="icb-slot-img" src="'+esc(c.img)+'" alt="">'+
 '<div class="icb-slot-name"><span class="icb-slot-n"><b class="icb-hl">FREE</b> lace converter</span><span class="icb-slot-t">'+esc(c.color)+'</span></div>'+
 '<button type="button" class="icb-gchoose">Choose</button></div></div>';
}
// color picker: same sheet look as "Pick a glove"
var sheet=document.createElement('div');
sheet.className='icb-sheet'; sheet.id='icb-csheet'; sheet.hidden=true;
sheet.innerHTML='<div class="icb-sheet-bg" data-cclose></div><div class="icb-sheet-panel" role="dialog" aria-modal="true" aria-label="Free lace converter">'+
 '<div class="icb-sheet-head"><b>Free lace converter</b><button type="button" class="icb-sheet-x" data-cclose aria-label="Close">&times;</button></div>'+
 '<div class="icb-sheet-grid" id="icb-csheet-grid"></div></div>';
document.body.appendChild(sheet);
var cgrid=sheet.querySelector('#icb-csheet-grid');
function openSheet(){
 var h='';
 CONV.forEach(function(o,k){h+='<button type="button" class="icb-sheet-item'+(k===pick?' is-on':'')+'" data-gc="'+k+'"><img src="'+esc(o.img)+'" alt="" loading="eager"><span>'+esc(cap(o.color))+'</span></button>';});
 cgrid.innerHTML=h; sheet.hidden=false; document.body.style.overflow='hidden';
}
function closeSheet(){ sheet.hidden=true; document.body.style.overflow=''; }
sheet.addEventListener('click',function(e){
 if(e.target.closest('[data-cclose]')){ closeSheet(); return; }
 var it=e.target.closest('.icb-sheet-item'); if(!it) return;
 pick=Number(it.dataset.gc); closeSheet();
 var old=root.querySelector('.icb-gift'); if(old) old.outerHTML=giftHtml();
});
document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !sheet.hidden) closeSheet(); });
root.addEventListener('click',function(e){ if(e.target.closest('.icb-gchoose')){ e.stopPropagation(); openSheet(); } });

var busy=false;
function sync(){
 if(busy) return; busy=true;
 var b2=root.querySelector('.icb-tier-body[data-body="2"]');
 if(b2 && root.dataset.qty==='2' && b2.children.length && !b2.querySelector('.icb-gift')) b2.insertAdjacentHTML('beforeend',giftHtml());
 root.querySelectorAll('.icb-slot-n').forEach(function(n){
  if(!n.querySelector('b') && /· 30% off/i.test(n.textContent)) n.innerHTML=esc(n.textContent.replace(/\s*·\s*30% off/i,''))+' · <b class="icb-hl">30% OFF</b>';
 });
 var note=document.getElementById('icb-atc-note');
 if(note && /free shipping/.test(note.textContent) && !/lace converter/.test(note.textContent) && !note.style.color)
   note.textContent=note.textContent.replace('free shipping','free lace converter + free shipping');
 root.querySelectorAll('.icb-nudge-s').forEach(function(n){ if(!/lace converter/.test(n.textContent)) n.textContent='30% off the 2nd pair + free lace converter + free shipping'; });
 busy=false;
}
new MutationObserver(sync).observe(root,{subtree:true,childList:true,characterData:true});

// add the free converter with the 2 pairs (only one per cart)
var of=window.fetch;
window.fetch=function(url,opt){
 var self=this;
 try{
  if(typeof url==='string' && url.indexOf('/cart/add')===0 && opt && typeof opt.body==='string' && root.dataset.qty==='2'){
   var b=JSON.parse(opt.body);
   if(b.items && b.items.reduce(function(t,i){return t+(Number(i.quantity)||1);},0)>=2 && !b.items.some(function(i){return i.properties && i.properties.Gift;})){
    return of.call(self,'/cart.js').then(function(r){return r.json();}).then(function(cart){
     var has=(cart.items||[]).some(function(i){return i.properties && i.properties.Gift;});
     if(!has){
      var c=CONV[pick]||CONV[0]; b.items.push({id:Number(c.id),quantity:1,properties:{Gift:'Free with 2 pairs'}});
      opt=Object.assign({},opt,{body:JSON.stringify(b)});
     }
     return of.call(self,url,opt);
    },function(){ return of.call(self,url,opt); });
   }
  }
 }catch(err){}
 return of.call(this,url,opt);
};
sync(); setTimeout(sync,600); setTimeout(sync,1500);
})();
